import { changePassword, saveProfile } from '../repositories/ProfileRepository'

const useProfile = () => {
    const handleSaveProfile = (newUserInfo, onSaved, onError) => {
        return saveProfile(newUserInfo)
            .then(onSaved)
            .catch(onError)
    }

    const handleChangePassword = (newInfo, onChanged, onError) => {
        return changePassword(newInfo)
            .then(onChanged)
            .catch(onError)
    }

    return {
        handleSaveProfile,
        handleChangePassword,
    }
}

export default useProfile
